import "./Roasters.module.css";
import Header from "@/reusable_sections/Header";
import FilterBar from "./sections/FilterBar";
import RoasterGrid from "./sections/RoasterGrid";
import ExploreMore from "./sections/ExploreMore";
import Footer from "@/reusable_sections/Footer";
export default function RoastersPage() {
  return <div>
      <Header />
      <FilterBar />
      <RoasterGrid />
      <ExploreMore />
      <Footer />
    </div>;
}